/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    rowSpacing,
    fontSizeDesktop,
    enterpriseCSS,
    paletteHD,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const MobileOrderListStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        MobileOrderListStyle: {
            maxWidth: newPalette.myAccount.container.maxWidth.downSmall,
            '& .order-list-wrapper': {
                border: `2px solid ${enterpriseCSS.palette.gray3}`,
            },

            '& .orderHeader': {
                display: 'flex',
                fontSize: fontSizeDesktop.title,
                fontWeight: '700',
                textTransform: 'uppercase',
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                backgroundColor: enterpriseCSS.palette.gray3,

                '& .orderHeaderItem': {
                    display: 'inline-block',

                    '& .headerItemLabel': {
                        color: enterpriseCSS.palette.gray1,
                    },

                    '& .partOrderNumber': {
                        fontWeight: 'normal',
                    },

                    '& .orderDate': {
                        textTransform: 'initial',
                    },
                },
            },

            '& .orderItemGrid': {
                paddingBottom: '50px',
                width: 'calc(100% - 35px)',
                margin: '0 auto',
                '&:not(:first-of-type) ': {
                    borderTop: `${'2px dashed'} ${enterpriseCSS.palette.gray3}`,
                },
            },

            '& .orderStatusInfo': {
                '& .orderDetail': {
                    marginTop: rowSpacing,
                    marginLeft: rowSpacing * 9,
                },
            },

            '& .productInnerDiv': {
                minHeight: rowSpacing * 11,
                position: 'relative',
                borderRadius: '3px',
                border: `1px solid ${newPalette.checkout?.borderColor}`,
                '& .headerItemLabel': {
                    padding: '15px 15px 15px 20px',
                    borderBottom: `1px solid ${newPalette.checkout?.borderColor}`,
                    backgroundColor: newPalette.desktopBgFooter,
                    fontWeight: 700,
                    fontSize: '16px',
                    letterSpacing: '0.3px',
                },
                '& .productContainer': {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px 15px 15px 20px',
                    '& .productTitle': {
                        textTransform: 'none',
                        fontSize: '12px',
                        color: newPalette.common?.darkGray,
                        paddingBottom: '8px',
                    },
                    '& .productLink': {
                        textTransform: 'none',
                        textDecoration: 'underline',
                        fontSize: '14px',
                        color: newPalette.colorPrimary,
                        margin: '5px 0',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        display: 'block',
                        textAlign: 'left',
                    },
                    '& .productInfo': {
                        textTransform: 'none',
                        fontSize: '14px',
                        fontWeight: '700',
                        color: newPalette.common?.black,
                        margin: '5px 0',
                    },
                },
            },
            // Status tracking bar
            ...StatusTrackingBar(typography, newPalette).StatusTrackingBar,
        },
    };
};
